import { Alert } from 'reactstrap';
import { FaLightbulb } from 'react-icons/fa';
import { DunningReminderBlockType } from '../../graphql/generatedTypes';
import i18n from '@/utils/i18n';
import { getDateFormatOptions } from '../../utils/i18n';

type DunningReminderBlockStatusProps = {
  blockType: DunningReminderBlockType | null | undefined;
  blockUntil: string | null | undefined;
  blockReason: string | null | undefined;
  translationNamespace: 'Invoices' | 'Billing';
  isBlocked: boolean;
};

export const DunningReminderBlockStatus = ({
  blockType,
  blockUntil,
  blockReason,
  translationNamespace,
  isBlocked,
}: DunningReminderBlockStatusProps) => {
  const getStatusText = () => {
    if (!isBlocked) {
      return i18n.t(
        `${translationNamespace}:dunningReminderBlockStatusDisabled`,
      );
    }

    if (blockType === DunningReminderBlockType.Temporary) {
      if (blockUntil) {
        return i18n.t(
          `${translationNamespace}:dunningReminderBlockStatusTemporaryUntil`,
          {
            date: new Date(blockUntil).toLocaleDateString(
              i18n.language,
              getDateFormatOptions(false),
            ),
          },
        );
      } else {
        return i18n.t(
          `${translationNamespace}:dunningReminderBlockTypeTemporary`,
        );
      }
    } else {
      return i18n.t(
        `${translationNamespace}:dunningReminderBlockStatusPermanently`,
      );
    }
  };

  return (
    <Alert color={isBlocked ? 'warning' : 'info'} className="mb-3">
      <div className="d-flex">
        <div className="align-self-center">
          <FaLightbulb />
        </div>
        <div className="ms-2">
          <strong>
            {i18n.t(`${translationNamespace}:dunningReminderBlockType`)}:{' '}
          </strong>
          {isBlocked ? (
            <>
              {i18n.t(
                `${translationNamespace}:dunningReminderBlockStatusEnabled`,
              )}{' '}
              - {getStatusText()}
              {blockReason && (
                <>
                  <br />
                  <strong>
                    {i18n.t(
                      `${translationNamespace}:dunningReminderBlockReason`,
                    )}
                    :{' '}
                  </strong>
                  {blockReason}
                </>
              )}
            </>
          ) : (
            getStatusText()
          )}
        </div>
      </div>
    </Alert>
  );
};
